module.exports = __webpack_public_path__ + "img/рз_22.4d47cb20.png";